import {useState, useEffect} from "react"
import {useParams} from "react-router-dom"
import axios from "axios"
import {API_PROJECTS} from "../../constants/apiUrls"
import useStProject from "../../swrCustomHooks/useStProject"
import useTries from "../../swrCustomHooks/useTries"
import StWorkflowHeader from "../../sections/st-workflow-header/StWorkflowHeader"
import LexiconsModal from "../../sections/lexicons-modal/LexiconsModal"
import StWorkflowContent from "../../sections/st-workflow-content/StWorkflowContent"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import ConfirmationModal from "../../components/confirmation-modal/ConfirmationModal"
import {useNavigate} from "react-router-dom"
import RequireStLicence from "../../tools/RequireStLicence"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import {useLexiconsContext} from "../../reactContext/contextCustomHooks/useLexiconsContext"
import {useStProjectsContext} from "../../reactContext/contextCustomHooks/useStProjectsContext"
import {useStWorkflowContext} from "../../reactContext/contextCustomHooks/useStWorkflowContext"
import {toast} from "react-toastify"
import {useTranslation} from "react-i18next"

export default function StWorkflow() {
    const {t} = useTranslation()
    const params = useParams()
    const {sessionContext} = useSessionContext()
    const {teamContext} = useTeamContext()
    const {stProjectsContext, setStProjectsAction} = useStProjectsContext()
    const {stWorkflowContext} = useStWorkflowContext()
    const {lexiconsContext} = useLexiconsContext()
    const {stProject, mutateStProject, isLoadingStProject, isErrorStProject} = useStProject(params?.projectID)
    const {tries, mutateTries, isLoadingTries, isErrorTries} = useTries(params?.projectID)
    const [workflowStep, setWorkflowStep] = useState()
    const [workflowNavigation, setWorkflowNavigation] = useState(-1)
    const [maxStep, setMaxStep] = useState(5)
    const [isPulling, setIsPulling] = useState(stProject?.ongoing_process)
    const [isUpdateWorkflowNavigation, setIsUpdateWorkflowNavigation] = useState(true)
    const headersRequest = {headers: {Authorization: `Bearer ${sessionContext?.idToken}`}}
    let navigate = useNavigate()
    let intervalID

    const pullingTries = () => {
        axios.get(`${API_PROJECTS}/${params.projectID}/tries`, headersRequest)
        .then((response) => {
            const trie = response.data[0]
            if (trie.status_code === "done" || trie.status_code === "failed") {
                if (trie.status_code === "done" && isUpdateWorkflowNavigation) {
                    setWorkflowNavigation(workflowNavigation + 1)
                }
                mutateStProject()
                setIsPulling(false)
                clearInterval(intervalID)
                intervalID = null
                setIsUpdateWorkflowNavigation(true)
            }
        })
        .catch((error) => {
            console.error("GET /projects/project/tries: ", error)
        })
    }

    const exportStProject = (value) => {
        return new Promise((resolve, reject) => {
            if (value) {
                axios.get(`${API_PROJECTS}/${stProjectsContext.projectID}/archive.zip`, headersRequest, {maxRedirects: 0})
                .then((response) => {
                    var link = document.createElement("a")
                    link.href = response.data
                    link.click()
                    mutateStProject()
                    toast.success(t("Your project has been exported!"))
                    resolve()
                })
                .catch(() => {
                    toast.error(t("An error has occurred"))
                    reject()
                })
            } else {
                resolve()
            }
        })
    }

    useEffect(() => {
        sessionContext.role === "admin" && navigate("/neurowide-dashboard")
        setStProjectsAction({type: "SET_ST_PROJECT_ID", payload: {projectID: params.projectID}})
        mutateTries()
        if (isPulling) {
            window.scrollTo(0, 0)
            intervalID = setInterval(pullingTries, 10000)
        }
    }, [workflowStep, isPulling])

    if (isErrorStProject || isErrorTries || isLoadingStProject || isLoadingTries || stProject.message || tries.message) return <LoadingComponent/>
    return (
        <>
        <RequireStLicence types={teamContext.licenceTypes} redirect={true}>
            <div className="VIEW ST-WORKFLOW">
                {(stWorkflowContext.isConfirmationModal.modal && stWorkflowContext.isConfirmationModal.id === stProjectsContext.projectID) && <ConfirmationModal type={"st-export"} exportStProject={exportStProject} modalMessage={`Your project will no longer be editable. Would you like to continue?`}/>}
                {lexiconsContext.isModal && <LexiconsModal type={"select"} mutateStProject={mutateStProject}/>}
                <StWorkflowHeader project={stProject} step={workflowStep} workflowNavigation={workflowNavigation} setWorkflowNavigation={setWorkflowNavigation} maxStep={maxStep}/>
                <StWorkflowContent params={{
                    project: stProject,
                    mutateStProject: mutateStProject,
                    tries: tries,
                    workflowNavigation: workflowNavigation,
                    setWorkflowStep: setWorkflowStep,
                    setWorkflowNavigation: setWorkflowNavigation,
                    setMaxStep: setMaxStep,
                    isPulling: isPulling,
                    setIsPulling: setIsPulling,
                    setIsUpdateWorkflowNavigation: setIsUpdateWorkflowNavigation,
                    exportStProject: exportStProject,
                }}/>
            </div>
        </RequireStLicence>
        </>
    )
}